export default __webpack_public_path__ + "static/media/102.8362445e.png";